import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

export interface GalleryPhoto {
  key: string;
  url: string;
  filename: string;
}

interface PhotoGalleryProps {
  photos: GalleryPhoto[];
  size?: number;
  selectable?: boolean;
  selectedKeys?: Set<string>;
  onToggle?: (key: string) => void;
  onRemove?: (key: string) => void;
  removeLabel?: string;
  emptyText?: string;
}

export default function PhotoGallery({
  photos,
  size = 90,
  selectable,
  selectedKeys,
  onToggle,
  onRemove,
  removeLabel = 'Remove',
  emptyText,
}: PhotoGalleryProps) {
  if (photos.length === 0) {
    return emptyText ? <div style={{ fontSize: 13, color: '#9ca3af' }}>{emptyText}</div> : null;
  }

  return (
    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
      {photos.map((photo) => {
        const selected = !!selectable && !!selectedKeys?.has(photo.key);
        return (
          <div key={photo.key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <img
              src={photo.url}
              alt={photo.filename}
              title={photo.filename}
              onClick={() => (selectable ? onToggle?.(photo.key) : window.open(photo.url, '_blank'))}
              style={{
                width: size,
                height: size,
                objectFit: 'cover',
                borderRadius: 4,
                border: selected ? '2px solid #4f46e5' : '1px solid #e5e7eb',
                boxShadow: selected ? '0 0 0 2px rgba(79,70,229,0.2)' : undefined,
                cursor: 'pointer',
              }}
            />
            {selectable && (
              <span style={{ fontSize: 10, color: selected ? '#4f46e5' : '#9ca3af', fontWeight: selected ? 700 : 400 }}>
                {selected ? 'Selected' : 'Select'}
              </span>
            )}
            {onRemove && (
              <button
                onClick={() => onRemove(photo.key)}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: 11, padding: '1px 4px' }}
                title={`Remove ${photo.filename}`}
              >
                <DeleteIcon sx={{ fontSize: 13 }} />
                {removeLabel}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
